/**
 * Whether this visitor gets the real-time 3D scenes (hero, PreMize) or keeps
 * the static fallbacks. Any one of these keeps the fallback:
 *   - `navigator.webdriver` — the prerender and other automation;
 *   - `prefers-reduced-motion: reduce` or `Save-Data`;
 *   - no WebGL2.
 * `?hero3d=1` forces the 3D on and `?hero3d=0` forces it off, for comparison.
 *
 * index.html's head script applies the same gate before the first paint (it
 * only checks that WebGL2 exists, not that a context can be made); keep the
 * two in step.
 */
export function wants3D(): boolean {
  const q = new URLSearchParams(window.location.search).get('hero3d');
  if (q === '0') return false;
  if (q === '1') return true;
  if (navigator.webdriver) return false;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
  const conn = (navigator as Navigator & { connection?: { saveData?: boolean } }).connection;
  if (conn?.saveData) return false;
  try {
    return !!document.createElement('canvas').getContext('webgl2');
  } catch {
    return false;
  }
}
